import React from "react";
import Abt from "../assets/About.jpg";

const Certificates = () => {
  return (
    <div name="about" className=" w-2/3 mx-auto font-semibold">
      <div className="text-4xl font-bold text-center my-11">Certificates</div>

      <div className=" flex flex-col md:grid grid-cols-3 grid-rows-2 gap-8 place-items-stretch mt-36 ">
        <div className="flex justify-center w-full">
          <div className="block p-6 rounded-lg shadow-lg bg-white hover:bg-transparent  antialiased max-w-sm">
            <h5 className="text-cyan-500  text-xl leading-tight font-medium mb-2">
              Udemy Certified
            </h5>
            <p className="text-gray-700 text-base my-6 bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500">
              The Complete 2022 Web Development Bootcamp
            </p>
            <a
              href="https://udemy-certificate.s3.amazonaws.com/image/UC-2b1e86ac-c278-4a1e-bf99-7f225241c60c.jpg?v=1665750289000"
              className=" inline-block px-6 py-2.5 bg-blue-300 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              download={false}>
              Check
            </a>
          </div>
        </div>
        <div className="row-span-3  place-self-center ">
          <img src={Abt} alt="abt" />
        </div>
        <div className="flex justify-center">
          <div className="block p-6 rounded-lg shadow-lg bg-white hover:bg-transparent max-w-sm">
            <h5 className=" text-xl text-cyan-500 leading-tight font-medium mb-2">
              Udemy Certified
            </h5>
            <p className="text-gray-700 text-base my-6 bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500">
              Ethereum Blockchain Developer Bootcamp With Solidity (2022)
            </p>
            <a
              href="https://udemy-certificate.s3.amazonaws.com/image/UC-fdee4552-5899-49e2-a01b-9d57cc0994f4.jpg?v=1656853546000"
              className=" inline-block px-6 py-2.5 bg-blue-300 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              download={false} >
              Check
            </a>
          </div>
        </div>
        <div className="flex justify-center">
          <div className="block p-6 rounded-lg shadow-lg bg-white hover:bg-transparent max-w-sm">
            <h5 className="text-cyan-500 text-xl leading-tight font-medium mb-2">
              Graduation
            </h5>
            <p className="text-gray-700 text-base my-6 bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500">
              B-tech in Mechanical Engineering, R.T.U Certified.
            </p>
            <a
              href = "https://gateway.pinata.cloud/ipfs/QmYHEEfmeKKVdekikXMY6K4tEpnYbABZZG2mXhpQQobsxT?_gl=1*yneafu*_ga*MTQxNDg5NDE4Ny4xNjY0MTY2ODM2*_ga_5RMPXG14TE*MTY3NjIwMDQzOC41LjEuMTY3NjIwMTcyNC4yMi4wLjA."
              className=" inline-block px-6 py-2.5 bg-blue-300 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
               download={false}>
              Check
              </a>
           
          </div>
        </div>
        <div className="flex justify-center">
          <div className="block p-6 rounded-lg shadow-lg bg-white hover:bg-transparent max-w-sm">
            <h5 className="text-cyan-500  text-xl leading-tight font-medium mb-2">
              Udemy Certified
            </h5>
            <p className="text-gray-700 text-base mb-4 bg-clip-text hover:text-transparent hover:bg-gradient-to-r from-pink-500 via-red-500 to-yellow-500">
              Advanced Solidity: Understanding and Optimizing Gas Costs
            </p>
            <a
              href="https://udemy-certificate.s3.amazonaws.com/image/UC-3e270fff-c75a-4de6-a8bd-d65fd95b5823.jpg"
              className=" inline-block px-6 py-2.5 bg-blue-300 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              download={false} >
              Check
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Certificates;
